import { useEffect } from 'react';
import { authService } from '../services/authService';

/**
 * Vuelta del Checkout de Stripe sin pagar (`?subscription_canceled=true`).
 * Si la cuenta se creó hace poco desde /pricing para contratar el plan y no
 * tiene pagos ni datos, calc-api la elimina (DELETE /api/auth/pending-signup).
 * En ese caso se cierra la sesión y se vuelve a /pricing. Cualquier otro
 * usuario (p. ej. uno gratuito que cancela el pago) no se ve afectado.
 */
export const isCheckoutCanceledReturn = (search) => {
  const params = new URLSearchParams(search);
  return params.get('subscription_canceled') === 'true' || params.get('canceled') === 'true';
};

const DiscardUnpaidSignup = () => {
  useEffect(() => {
    if (!isCheckoutCanceledReturn(window.location.search)) return;
    if (!authService.isAuthenticated()) return;
    let cancelled = false;
    (async () => {
      const deleted = await authService.discardPendingSignup();
      if (cancelled || !deleted) return;
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.replace('/pricing/');
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
};

export default DiscardUnpaidSignup;
